var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-toolbar",
        { attrs: { color: "primary", dark: "", dense: "", elevation: "0" } },
        [_c("span", [_vm._v("List")])]
      ),
      _c("v-data-table", {
        attrs: { items: _vm.feedingProgramCategoryList, headers: _vm.headers },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function({ item }) {
              return [
                _c("tr", [
                  _c("td", [_vm._v(_vm._s(item.id))]),
                  _c("td", [_vm._v(_vm._s(item.order))]),
                  _c("td", [_vm._v(_vm._s(item.stock_category_id))]),
                  _c("td", [_vm._v(_vm._s(item.description))]),
                  _c(
                    "td",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "yellow darken-3",
                            text: "",
                            "x-small": ""
                          },
                          on: {
                            click: function($event) {
                              return _vm.$emit("edit", item)
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("mdi-pencil")])],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }